import Icon from "@mui/icons-material/HowToReg";
import RazaEventsUpcomingList from "./RazaEventsUpcomingList";

export default {
  list: RazaEventsUpcomingList,
  icon: Icon,
  label: "Ohbat Attendance",
  options: { label: "Ohbat Attendance" },
  name: "razaEventsUpcoming",
};
